module.exports = __webpack_public_path__ + "img/9788954614542.ec028894.jpg";